import { object } from "prop-types";
import submit from "submit-form";

import Modal from "../../../../parts/modal-new";
import { getTestEmail } from "../../../../utils/user-helpers";

const sendInvite = (e, email, googlePlayLink, appStoreLink) => {
  e.preventDefault();
  submit(`/coaching-portal/athletes/invite-athlete`, {
    method: "POST",
    body: {
      email,
      googlePlayLink,
      appStoreLink,
    },
  });
};

const TestAccountModal = (props, { locals }) => {
  const testEmail = getTestEmail(locals.activeUser.email);
  const googlePlayLink =
    locals.activeUser.appStoreListingEnable && locals.activeUser.googlePlayLink
      ? locals.activeUser.googlePlayLink
      : "https://play.google.com/store/apps/details?id=com.mystrengthbook&hl=en_US&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1";
  const appStoreLink =
    locals.activeUser.appStoreListingEnable && locals.activeUser.appStoreLink
      ? locals.activeUser.appStoreLink
      : "https://apps.apple.com/us/app/mystrengthbook/id1337179045";
  const referAsClients = locals.activeUser.referAsClients;
  return (
    <Modal
      canClose={false}
      title={"Setup Test Account"}
      narrow
      className="test-account-modal"
    >
      <div className="body">
        <h4 className="mt-0 mb-6">
          Check your email inbox after sending the invite!
        </h4>
        <p className="p2 mb-4">
          Test your mobile app as {referAsClients ? "a client" : "an athlete"}.
          After sending the invite you will receive an email to your inbox{" "}
          <span className="text-[--information]">
            {locals.activeUser.email}
          </span>
          . This will include the instructions to install and access the app as
          a client.
        </p>
        <span className="chip info mb-2 h-8 py-0 ">
          Test account email: {testEmail}
        </span>
        <span className="chip warning h-8 py-0">
          You will not be charged for this
        </span>
      </div>
      <footer>
        <a
          role="button"
          data-button-type="primary"
          onClick={(e) =>
            sendInvite(e, testEmail, googlePlayLink, appStoreLink)
          }
        >
          Send Invite
        </a>
      </footer>
    </Modal>
  );
};

TestAccountModal.contextTypes = { locals: object };
export default TestAccountModal;
